import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import API from '../../services/api';

export default function OffersPage() {
  const navigate = useNavigate();
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    API.get('/offers').then(({ data }) => setOffers(data)).catch(console.error).finally(() => setLoading(false));
  }, []);

  return (
    <div style={{ minHeight: '100vh', background: '#080c14', fontFamily: "'Exo 2',sans-serif", color: '#e2e8f0', overflowX: 'hidden' }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Rajdhani:wght@600;700&family=Exo+2:wght@400;600;700;900&display=swap');
        *,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
        @keyframes pulse{0%,100%{opacity:.5}50%{opacity:1}}
        .op-bg{position:fixed;inset:0;background-image:linear-gradient(rgba(245,166,35,.025) 1px,transparent 1px),linear-gradient(90deg,rgba(245,166,35,.025) 1px,transparent 1px);background-size:50px 50px;pointer-events:none;z-index:0}
        .op-glow{position:fixed;bottom:-20%;left:-10%;width:60vw;height:60vw;background:radial-gradient(circle,rgba(245,166,35,.05) 0%,transparent 70%);pointer-events:none;z-index:0}
        .op-nav{position:sticky;top:0;background:rgba(8,12,20,.96);backdrop-filter:blur(12px);border-bottom:1px solid rgba(245,166,35,.08);z-index:100}
        .op-nav-inner{max-width:1200px;margin:0 auto;padding:0 20px;height:62px;display:flex;align-items:center;gap:20px}
        .op-logo{display:flex;align-items:center;gap:7px;text-decoration:none;flex-shrink:0}
        .op-logo-text{font-family:'Rajdhani',sans-serif;font-size:19px;font-weight:700;color:#f5a623;letter-spacing:5px}
        .op-nav-links{display:flex;gap:20px;flex:1}
        .op-nav-link{color:rgba(255,255,255,.45);text-decoration:none;font-size:13px;font-weight:600;letter-spacing:1px}
        .op-nav-link:hover{color:#f5a623}
        .op-login-btn{background:#f5a623;color:#080c14;padding:7px 15px;border-radius:8px;text-decoration:none;font-size:12px;font-weight:900;letter-spacing:1px;flex-shrink:0}
        .op-hamburger{display:none;background:none;border:1px solid rgba(245,166,35,.25);color:#f5a623;font-size:17px;cursor:pointer;padding:5px 9px;border-radius:7px;margin-left:auto}
        .op-mobile-menu{display:none;position:fixed;top:62px;left:0;right:0;background:rgba(8,12,20,.98);backdrop-filter:blur(12px);border-bottom:1px solid rgba(245,166,35,.1);padding:14px 20px;flex-direction:column;gap:4px;z-index:99}
        .op-mobile-menu.open{display:flex}
        .op-mobile-link{color:rgba(255,255,255,.6);text-decoration:none;font-size:14px;font-weight:600;padding:11px 0;border-bottom:1px solid rgba(255,255,255,.05);display:block}
        .op-inner{max-width:1200px;margin:0 auto;padding:40px 20px;position:relative;z-index:1}
        .op-header{text-align:center;margin-bottom:36px}
        .op-tag{color:rgba(245,166,35,.6);font-size:10px;font-weight:900;letter-spacing:4px;margin-bottom:8px}
        .op-title{font-family:'Rajdhani',sans-serif;font-size:clamp(28px,5vw,52px);font-weight:700;color:#e2e8f0;margin-bottom:8px}
        .op-sub{color:rgba(255,255,255,.3);font-size:14px}
        .op-banner{position:relative;background:linear-gradient(135deg,rgba(245,166,35,.08),rgba(0,212,255,.05));border:1px solid rgba(245,166,35,.15);border-radius:18px;padding:24px;margin-bottom:40px;overflow:hidden}
        .op-banner-content{display:flex;align-items:center;gap:16px;flex-wrap:wrap}
        .op-banner-icon{font-size:40px;flex-shrink:0}
        .op-banner-title{font-family:'Rajdhani',sans-serif;font-size:20px;font-weight:700;color:#e2e8f0;margin-bottom:3px}
        .op-banner-sub{color:rgba(255,255,255,.35);font-size:13px}
        .op-banner-btn{margin-left:auto;background:#f5a623;border:none;border-radius:11px;padding:11px 22px;color:#080c14;font-size:13px;font-weight:900;letter-spacing:1px;cursor:pointer;flex-shrink:0;font-family:'Rajdhani',sans-serif;white-space:nowrap}
        .op-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(280px,1fr));gap:18px}
        .op-card{background:#0d1420;border-radius:18px;border:1px solid rgba(245,166,35,.08);overflow:hidden;position:relative;transition:all .25s}
        .op-card:hover{transform:translateY(-5px);border-color:rgba(245,166,35,.3)}
        .op-card-img{width:100%;height:170px;object-fit:cover;display:block}
        .op-card-ph{width:100%;height:120px;background:rgba(245,166,35,.04);display:flex;align-items:center;justify-content:center;font-size:44px}
        .op-excl{position:absolute;top:11px;left:11px;background:linear-gradient(90deg,#f5a623,#00aaff);color:#080c14;font-size:9px;font-weight:900;letter-spacing:2px;border-radius:5px;padding:3px 9px}
        .op-card-body{padding:18px}
        .op-card-name{font-size:17px;font-weight:700;color:#e2e8f0;margin-bottom:5px;font-family:'Rajdhani',sans-serif}
        .op-card-sub{color:#f5a623;font-size:12px;margin-bottom:8px}
        .op-card-desc{color:rgba(255,255,255,.3);font-size:12px;line-height:1.6;margin-bottom:14px}
        .op-card-footer{display:flex;align-items:center;justify-content:space-between;gap:10px}
        .op-timer{display:flex;align-items:center;gap:5px}
        .op-timer-dot{width:6px;height:6px;border-radius:50%;background:#ff6b6b;animation:pulse 1.5s infinite;flex-shrink:0}
        .op-timer-text{color:rgba(255,255,255,.3);font-size:11px}
        .op-claim-btn{background:linear-gradient(90deg,#f5a623,#00aaff);border:none;border-radius:9px;padding:9px 18px;color:#080c14;font-size:12px;font-weight:900;letter-spacing:1px;cursor:pointer;font-family:'Rajdhani',sans-serif;transition:opacity .2s;white-space:nowrap}
        .op-claim-btn:hover{opacity:.85}
        .op-loading,.op-empty{text-align:center;color:rgba(255,255,255,.25);padding:70px;font-size:14px}
        .op-footer{border-top:1px solid rgba(245,166,35,.06);padding:22px;text-align:center;position:relative;z-index:1}
        .op-footer-text{color:rgba(255,255,255,.2);font-size:12px}
        .op-footer-link{color:rgba(245,166,35,.5);text-decoration:none}
        @media(max-width:768px){
          .op-nav-links,.op-login-btn{display:none}
          .op-hamburger{display:block}
          .op-grid{grid-template-columns:1fr}
          .op-inner{padding:32px 16px}
          .op-banner-btn{width:100%;text-align:center;margin-left:0}
          .op-banner-content{flex-direction:column;align-items:flex-start}
        }
        @media(max-width:480px){
          .op-card-footer{flex-direction:column;align-items:stretch}
          .op-claim-btn{text-align:center}
        }
      `}</style>
      <div className="op-bg" />
      <div className="op-glow" />

      <nav className="op-nav">
        <div className="op-nav-inner">
          <Link to="/" className="op-logo"><img src="/logo.jpg" alt="MegaFishHub" style={{ height: "38px", width: "auto", objectFit: "contain" }} /></Link>
          <div className="op-nav-links">
            <Link to="/" className="op-nav-link">Home</Link>
            <Link to="/games" className="op-nav-link">Games</Link>
            <Link to="/support" className="op-nav-link">Support</Link>
          </div>
          <Link to="/login" className="op-login-btn">→ LOGIN</Link>
          <button className="op-hamburger" onClick={() => setMenuOpen(!menuOpen)}>☰</button>
        </div>
      </nav>
      <div className={`op-mobile-menu${menuOpen ? ' open' : ''}`}>
        <Link to="/" className="op-mobile-link" onClick={() => setMenuOpen(false)}>🏠 Home</Link>
        <Link to="/games" className="op-mobile-link" onClick={() => setMenuOpen(false)}>🎮 Games</Link>
        <Link to="/support" className="op-mobile-link" onClick={() => setMenuOpen(false)}>💬 Support</Link>
        <Link to="/login" className="op-mobile-link" onClick={() => setMenuOpen(false)} style={{ color: '#f5a623' }}>→ Login</Link>
      </div>

      <div className="op-inner">
        <div className="op-header">
          <div className="op-tag">EXCLUSIVE DEALS</div>
          <h1 className="op-title">Hot Offers</h1>
          <p className="op-sub">Limited time deals — login to claim any offer instantly</p>
        </div>

        <div className="op-banner">
          <div className="op-banner-content">
            <div className="op-banner-icon">🎁</div>
            <div>
              <h2 className="op-banner-title">Members Get More</h2>
              <p className="op-banner-sub">Create a free account to unlock exclusive VIP deals, bonuses and rewards.</p>
            </div>
            <button className="op-banner-btn" onClick={() => navigate('/register')}>JOIN FREE →</button>
          </div>
        </div>

        {loading ? <div className="op-loading">Loading offers...</div>
          : offers.length === 0 ? <div className="op-empty">🎁 No offers right now — check back soon!</div>
          : (
            <div className="op-grid">
              {offers.map(offer => (
                <div key={offer._id} className="op-card">
                  <div style={{ position: 'relative' }}>
                    {offer.imageUrl ? <img src={offer.imageUrl} alt={offer.name} className="op-card-img" /> : <div className="op-card-ph">🎁</div>}
                    <div className="op-excl">EXCLUSIVE</div>
                  </div>
                  <div className="op-card-body">
                    <h3 className="op-card-name">{offer.name}</h3>
                    {offer.subtitle && <p className="op-card-sub">{offer.subtitle}</p>}
                    <p className="op-card-desc">{offer.description || ''}</p>
                    <div className="op-card-footer">
                      <div className="op-timer">
                        <span className="op-timer-dot" />
                        <span className="op-timer-text">Limited Time</span>
                      </div>
                      <button className="op-claim-btn" onClick={() => navigate('/login')}>🎁 CLAIM NOW</button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
      </div>

      <footer className="op-footer">
        <p className="op-footer-text">© 2025 MegaFishHub · <Link to="/privacy" className="op-footer-link">Privacy Policy</Link></p>
      </footer>
    </div>
  );
}